import type { ComponentProps } from "@blocknote/react";
import { DescriptionAccent, paddingStyles } from "ui";

type Props = ComponentProps["Generic"]["Menu"]["Label"];

export function Label({ children }: Props) {
  return <DescriptionAccent className={paddingStyles.p025}>{children}</DescriptionAccent>;
}
